import { FETCH_FOLLOWERS_SUCCESS } from '../../actions/fetch-followers';

export default function followersMetadataReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_FOLLOWERS_SUCCESS:
      return action.meta;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/followers/metadata.js